import React, { createContext, useContext, useState, useEffect } from 'react';

// Create Context
const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  let mockProducts = [
    {
      id: 1,
      name: 'Bengalgram Papad',
      description:
        'Crispy and delicious papad made from high-quality ingredients.',
      image: '/assets/img/products/papad1.png',
      size: '100gm',
      price: 40,
    },
    {
      id: 2,
      name: 'Potato chips',
      description:
        'Crispy and delicious papad made from high-quality ingredients.',
      image: '/assets/img/products/papad2.png',
      size: '200gm',
      price: 60,
    },
    {
      id: 3,
      name: 'Finger Papad',
      description:
        'Crispy and delicious papad made from high-quality ingredients.',
      image: '/assets/img/products/papad3.png',
      size: '150gm',
      price: 50,
    },
    {
      id: 4,
      name: 'Tomato Papad',
      description:
        'Crispy and delicious papad made from high-quality ingredients.',
      image: '/assets/img/products/papad4.jpg',
      size: '120gm',
      price: 45,
    },
    {
      id: 5,
      name: 'Bengalgram Papad',
      description:
        'Crispy and delicious papad made from high-quality ingredients.',
      image: '/assets/img/products/papad1.png',
      size: '100gm',
      price: 40,
    },
  ];
  //  Products
  const [products, setProducts] = useState(mockProducts);

  // 🛒 Cart Items
  let cartFromStorage = JSON.parse(localStorage.getItem('cart')) || [];

  const [cartItems, setCartItems] = useState(cartFromStorage);

  // 🛒 Cart Items
  const [favoriteItems, setFavoriteItems] = useState([]);

  // 🔍 Recent Searches
  const [recentSearches, setRecentSearches] = useState([]);

  // 👤 User Details
  const [user, setUser] = useState(null); // { id, name, email, token }
  const [cartFxToken, setCartFxToken] = useState(0);

  // ------------------------------------------------------------
  // 🛒 CART FUNCTIONS
  // 🛒 ADD or INCREMENT
  const addToCart = (item) => {
    setCartFxToken((current) => current + 1);
    setCartItems((prev) => {
      const existing = prev.find((p) => p.id === item.id);

      if (existing) {
        // ✅ increment count
        return prev.map((p) =>
          p.id === item.id ? { ...p, quantity: (p.quantity || 1) + 1 } : p
        );
      } else {
        // ✅ add new item
        return [...prev, { ...item, quantity: 1 }];
      }
    });
  };

  // ➖ DECREMENT or REMOVE
  const decreaseFromCart = (id) => {
    setCartItems(
      (prev) =>
        prev
          .map((p) =>
            p.id === id ? { ...p, quantity: (p.quantity || 1) - 1 } : p
          )
          .filter((p) => p.quantity > 0) // ✅ remove if count hits zero
    );
  };

  // 🚮 REMOVE ENTIRE ITEM
  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((p) => p.id !== id));
  };

  const clearCart = () => setCartItems([]);

  // ------------------------------------------------------------
  // Favorite FUNCTIONS
  const addToFavorite = (item) => {
    setFavoriteItems((prev) => {
      const existing = prev.find((p) => p.id === item.id);

      if (existing) {
        // ✅ increment count
        return prev.map((p) =>
          p.id === item.id ? { ...p, quantity: (p.quantity || 1) + 1 } : p
        );
      } else {
        // ✅ add new item
        return [...prev, { ...item, quantity: 1 }];
      }
    });
  };

  // 🚮 REMOVE ENTIRE ITEM
  const removeFromFavorite = (id) => {
    setFavoriteItems((prev) => prev.filter((p) => p.id !== id));
  };

  // ------------------------------------------------------------
  // 🔍 RECENT SEARCHES FUNCTIONS
  const addRecentSearch = (term) => {
    setRecentSearches((prev) => {
      const updated = [term, ...prev.filter((s) => s !== term)];
      return updated.slice(0, 10); // keep latest 10
    });
  };

  // ------------------------------------------------------------
  // 👤 USER FUNCTIONS
  const loginUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logoutUser = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // ------------------------------------------------------------
  // 🧠 PERSIST STATE IN LOCALSTORAGE
  useEffect(() => {
    let savedCart = [];
    let savedSearches = [];
    let savedUser = null;

    try {
      const cartRaw = localStorage.getItem('cart');
      if (cartRaw) savedCart = JSON.parse(cartRaw);
    } catch (e) {
      console.warn('Failed to parse cart from localStorage', e);
    }

    try {
      const searchesRaw = localStorage.getItem('recentSearches');
      if (searchesRaw) savedSearches = JSON.parse(searchesRaw);
    } catch (e) {
      console.warn('Failed to parse recentSearches from localStorage', e);
    }

    try {
      const userRaw = localStorage.getItem('user');
      if (userRaw) savedUser = JSON.parse(userRaw);
    } catch (e) {
      console.warn('Failed to parse user from localStorage', e);
    }

    setCartItems(savedCart);
    setRecentSearches(savedSearches);
    setUser(savedUser);
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
  }, [recentSearches]);

  // ------------------------------------------------------------
  // PROVIDE EVERYTHING
  const value = {
    cartItems,
    addToCart,
    decreaseFromCart,
    removeFromCart,
    clearCart,
    recentSearches,
    addRecentSearch,
    user,
    loginUser,
    logoutUser,
    favoriteItems,
    addToFavorite,
    removeFromFavorite,
    products,
    setProducts,
    cartFxToken,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
